module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



/*****************
 ** WEBPACK FOOTER
 ** ./~/atoa/atoa.js
 ** module id = 1017
 ** module chunks = 0
 **/